export type UserState = GuestUserState | LoggedInUserState;

export interface OptionalUserState {
  userData: LoggedInUserData | null;
}

export interface GuestUserState {
  checkoutSession: CheckoutSessionData | null;
  guestToken?: string;
}

export interface LoggedInUserState {
  checkoutSession: CheckoutSessionData;
  token: string;
}

export interface LoggedInUserData {
  id: number;
  gender: Exclude<UserGenders, UserGenders.Kids>;
  emailHash: EmailHash;
  email: string;
  firstName: string;
  lastName: string;
  isExistingCustomer: boolean;
  birthday: string;
  phone: string;
}

export enum UserGenders {
  Male = 'male',
  Female = 'female',
  Kids = 'kids',
}

interface CheckoutSessionData {
  cookieValue: string;
  secret: string;
}

interface EmailHash {
  emh: string;
  emhec: string;
}
